import { ModelBase } from '@skylab-shared/core';
import { ExchangeRateModel } from '@skylab-shared/dataModel';
import { RecursiveDiff } from '@skylab-shared/types';
import { CurrencyExchangeRate } from '../../currency/queries/currency-exchange-rate.query-base';

export function rewriteExchangeRateItemToDocumentExchangeRateModel(target: ExchangeRateModel, source: CurrencyExchangeRate): void {
    target.date = source.date;
    target.manual = source.manual;
    target.units = source.units;
    target.rate = source.rate;
    target.tableNo = source.tableNo;
}

export function rewriteExchangeRate(target: RecursiveDiff<ExchangeRateModel, ModelBase>, source: RecursiveDiff<ExchangeRateModel, ModelBase>): void {
    target.date = source.date;
    target.rate = source.rate;
    target.units = source.units;
    target.tableNo = source.tableNo;
}
